import type { Integration } from '../../../types/api';
import { FormField, FormLabel, FormInput } from '../../ui';

interface GammuTabProps {
  integration: Integration | null;
}

function GammuTab({ integration }: GammuTabProps) {
  return (
    <div className="space-y-6">
      <div className="grid grid-cols-2 gap-4">
        <FormField>
          <FormLabel htmlFor="gammu_user">Usuário Gammu</FormLabel>
          <FormInput id="gammu_user" name="gammu_user" defaultValue={integration?.gammu_user} />
        </FormField>

        <FormField>
          <FormLabel htmlFor="gammu_pwd">Senha Gammu</FormLabel>
          <FormInput
            type="password"
            id="gammu_pwd"
            name="gammu_pwd"
            defaultValue={integration?.gammu_pwd}
          />
        </FormField>
      </div>
    </div>
  );
}

export default GammuTab;
